export default __webpack_public_path__ + "static/media/samsung_monitor.4d147207.jpg";